var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useSwiper } from 'swiper/react';
var CarouselArrow = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'left' : _b, externalRef = _a.externalRef, _c = _a.isCustomClickEvent, isCustomClickEvent = _c === void 0 ? false : _c, _d = _a.customClickFunction, customClickFunction = _d === void 0 ? function (eventPayload) {
        //console.log('eventPayload', eventPayload);
    } : _d;
    var swiperHook = useSwiper();
    var isRight = direction === 'right';
    var rotateClassDirection = isRight ? "rotate-180" : "rotate-0";
    var positionText = isRight ? "Next" : "Before";
    var handleClick = function () {
        if (swiperHook) {
            if (isCustomClickEvent) {
                customClickFunction(isRight);
                return;
            }
            if (isRight) {
                swiperHook.slideNext();
            }
            else {
                swiperHook.slidePrev();
            }
        }
    };
    return (_jsx("button", __assign({ ref: externalRef, tabIndex: 0, "aria-label": "Go to " + positionText + " card", className: "carousel__button-controller carousel__button--" + direction + " rounded-full border border-white", "aria-labelledby": "cc-arrow-icon", onClick: handleClick }, { children: _jsx("svg", __assign({ className: "button-controller__icon h-10 transform stroke-current text-white " + rotateClassDirection + " ", viewBox: "0 0 40 41", stroke: "none", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "m22.306 15.16-5.384 5.384 5.384 5.384", fill: "none" }, void 0) }), void 0) }), void 0));
};
export default CarouselArrow;
